import script from "./ticket.vue?vue&type=script&lang=ts&setup=true"
export * from "./ticket.vue?vue&type=script&lang=ts&setup=true"

import "./ticket.vue?vue&type=style&index=0&id=68ebdd6b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ebdd6b"]])

export default __exports__